const wallpapers = [
    // ======================
    // PHONE
    // ======================
    { id: "phone-01", device: "phone", title: "Image 1", src: "/Wallpapers/Phone/image%20(1).webp" },
    { id: "phone-02", device: "phone", title: "Image 2", src: "/Wallpapers/Phone/image%20(2).webp" },
    { id: "phone-03", device: "phone", title: "Image 3", src: "/Wallpapers/Phone/image%20(3).webp" },
    { id: "phone-04", device: "phone", title: "Image 4", src: "/Wallpapers/Phone/image%20(4).webp" },
    { id: "phone-05", device: "phone", title: "Image 5", src: "/Wallpapers/Phone/image%20(5).webp" },

    { id: "phone-06", device: "phone", title: "Image", src: "/Wallpapers/Phone/image.webp" },

    { id: "phone-07", device: "phone", title: "Wallpaper Grzh", src: "/Wallpapers/Phone/wallpaper_grzh.webp" },
    { id: "phone-08", device: "phone", title: "Wallpaper Jim", src: "/Wallpapers/Phone/wallpaper_jim.webp" },
    { id: "phone-09", device: "phone", title: "Wallpaper Lucy", src: "/Wallpapers/Phone/wallpaper_lucy.webp" },
    { id: "phone-10", device: "phone", title: "Wallpaper Pain", src: "/Wallpapers/Phone/wallpaper_pain.webp" },
    { id: "phone-11", device: "phone", title: "Wallpaper Sig", src: "/Wallpapers/Phone/wallpaper_sig.webp" },
    { id: "phone-12", device: "phone", title: "Wallpaper Yanych", src: "/Wallpapers/Phone/wallpaper_yanych.webp" },

    // ======================
    // DESKTOP
    // ======================
    { id: "desktop-06", device: "desktop", title: "Image 6", src: "/Wallpapers/Desktop/image%20(6).webp" },
    { id: "desktop-07", device: "desktop", title: "Image 7", src: "/Wallpapers/Desktop/image%20(7).webp" },
    { id: "desktop-08", device: "desktop", title: "Image 8", src: "/Wallpapers/Desktop/image%20(8).webp" },
    { id: "desktop-09", device: "desktop", title: "Image 9", src: "/Wallpapers/Desktop/image%20(9).webp" },

    { id: "desktop-10", device: "desktop", title: "Image 10", src: "/Wallpapers/Desktop/image%20(10).webp" },
    { id: "desktop-11", device: "desktop", title: "Image 11", src: "/Wallpapers/Desktop/image%20(11).webp" },
    { id: "desktop-12", device: "desktop", title: "Image 12", src: "/Wallpapers/Desktop/image%20(12).webp" },
    { id: "desktop-13", device: "desktop", title: "Image 13", src: "/Wallpapers/Desktop/image%20(13).webp" },
    { id: "desktop-14", device: "desktop", title: "Image 14", src: "/Wallpapers/Desktop/image%20(14).webp" },
    { id: "desktop-15", device: "desktop", title: "Image 15", src: "/Wallpapers/Desktop/image%20(15).webp" },
    { id: "desktop-16", device: "desktop", title: "Image 16", src: "/Wallpapers/Desktop/image%20(16).webp" },
    { id: "desktop-17", device: "desktop", title: "Image 17", src: "/Wallpapers/Desktop/image%20(17).webp" },
];

export default wallpapers;
